import { createSlice } from "@reduxjs/toolkit";

export const formulaSlice = createSlice({
  name: "formula",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    formulaslist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    params: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getFormulas: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    formulaListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.params.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        formulaslist: action.payload.response.results,
        loading: false,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
      };
    },

    formulaAdd: (state) => {
      return {
        ...state,
        loading: false,
      };
    },

    formulaAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },

    formulaEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },

    formulaEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },

    formulaDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },

    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },

    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetParams: (state, action) => {
      return {
        ...state,
        params: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getFormulas,
  formulaListSuccessful,
  formulaAdd,
  formulaAddSuccessful,
  formulaEdit,
  formulaEditSuccessful,
  formulaDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
} = formulaSlice.actions;

export default formulaSlice.reducer;
